
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import ComCard from '../card/comCard.vue'
import { Observer } from 'mobx-vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Observer
@Component({
  components: {
    ComCard,
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource: ComCard[]
  @Prop() backgroundUrl: string

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
